/*
 * Lookbook JS. 2014
*/

// -------------------------------------------------------------------------------------
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// -------------------------------------------------------------------------------------
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function() { callback(currTime + timeToCall); },
       timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
  }
}());

// -------------------------------------------------------------------------------------
// Debounce function, taken from underscore.js
// -------------------------------------------------------------------------------------
function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

// -------------------------------------------------------------------------------------
// Run function after window resize
// -------------------------------------------------------------------------------------
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

// -------------------------------------------------------------------------------------
// Global Variables
// -------------------------------------------------------------------------------------
var w = getWidth(),
    h = getHeight(),
    desktopBreakPoint = 768,
    totalNavItemWidth = 0;

// -------------------------------------------------------------------------------------
// Functions
// -------------------------------------------------------------------------------------
function updateCoverImages() {
  if ( getWidth() < desktopBreakPoint ) {
    return;
  }

  $('.slide__image').each(function() {
    var el = $(this),
        iW = el.width();

    if (el.parent().hasClass('gallery__slide')) {
      el.parent().css('width', iW);
    } else {
      el.parent().parent().css('width', iW);
    }
  });

};

function onOrientationChange() {
  $('body').height(window.innerHeight);
};

function getWidth() {
  return window.innerWidth;
};

function getHeight() {
  return window.innerHeight;
};

function diff (a, b) {
  return Math.abs(a - b)
}


// -------------------------------------------------------------------------------------
// General theme JS
// -------------------------------------------------------------------------------------
$(function() {

  window.isTouch = 'ontouchstart' in document.documentElement;
  window.isiOS7 = navigator.userAgent.match(/iPad;.*CPU.*OS 7_\d/i);

  // -------------------------------------------------------------------------------------
  // Fixed iOS iPad landscape mode bug with 100% height
  // http://stackoverflow.com/questions/18855642/ios-7-css-html-height-100-692px
  // -------------------------------------------------------------------------------------
  if (isiOS7) {
    $('body').height(window.innerHeight);
    window.scrollTo(0, 0);
    window.addEventListener('orientationchange', onOrientationChange);
  }

  var navMenu = $('#navPrimary').hide();

  // Mobile menu toggle
  $('#toggleMobileNav').click(function(e){
    e.preventDefault();
    navMenu.slideToggle(350);
  });

  // Force show/hide the menu based on screen width
  function navVisibility() {

    if ( getWidth() != w ) {
      // The width changed, so update our global variable
      w = getWidth();

      // Toggle nav visibility based on width
      if ( getWidth() > desktopBreakPoint ) {
        navMenu.show();
      } else {
        navMenu.hide();
      }
    } else {
      // Width didn't change, but if we are on large screens show the nav
      if ( getWidth() > desktopBreakPoint ) {
        navMenu.show();
      }
      return;
    }

  };

  // Toggle product info
  var toggleProductInfo = $('.toggle__productinfo');
  if (toggleProductInfo.length) {
    toggleProductInfo.hover(function() {
     el = $(this);
     tar = $('.product__info', el);

     if ( w >= desktopBreakPoint ) {
       tar.toggleClass('product__infoshow');
     }
    });
  };

  // -------------------------------------------------------------------------------------
  // Functions run dependent on screen width. Must be updated on resizing.
  // -------------------------------------------------------------------------------------
  if ( $('html').hasClass('lt-ie9') ) {
    // Update .slide__image parent on delay - hack for oldIE
    setTimeout(function() {
      updateCoverImages();
    }, 400);

  } else {
    $(window).resize(function() {

      // recheck site width for nav visibility
      debounce( requestAnimationFrame(navVisibility), 250);

      // Update cover image container on resize
      debounce( requestAnimationFrame(updateCoverImages), 250);
    });
  }

  // Check what nav to show on load
  navVisibility();

  // -------------------------------------------------------------------------------------
  // Wrap tables from the rich text editor so you can define a scrollable area
  // -------------------------------------------------------------------------------------
  $('.rte table').wrap('<div class="table-wrap"></div>');

});

// -------------------------------------------------------------------------------------
// Once everything loaded, check image sizes
// -------------------------------------------------------------------------------------
$(window).load(function() {
  updateCoverImages();

  // -------------------------------------------------------------------------------------
  // Gallery specific functions
  // -------------------------------------------------------------------------------------
  var gallery = $('.gallery');
  if (gallery.length) {

    // Steal the scroll event for the gallery only
    var movement = 0;
    gallery.on('mousewheel', function(event) {
      if ( w >= desktopBreakPoint ) {
        event.preventDefault();
        if (event.deltaX > 0.5 || event.deltaX < -0.5) {
          this.scrollLeft += (event.deltaX * event.deltaFactor);
          arrowVisibility(this.scrollLeft);
        } else {
          this.scrollLeft += (event.deltaY * event.deltaFactor);
          arrowVisibility(this.scrollLeft);
        }
      };
    });


    // Keyboard/arrow scrolling
    var currentScroll = 0,
        isScrolling = false;

    // Setup keyboard arrow scroll capability
    $(document).keydown(function(event){
      switch (event.keyCode) {
        case 37: // left
          event.preventDefault();
          if (!isScrolling) {
            isScrolling = true;
            scrollGallery('left');
          }
          break;
        case 39: // right
          event.preventDefault();
          if (!isScrolling) {
            isScrolling = true;
            scrollGallery('right');
          }
          break;
      }
    });

    // Setup hover scroll capability if enabled in theme settings
    
      var leftArrow = '<div class="gallery-arrow gallery-left"></div>',
          rightArrow = '<div class="gallery-arrow gallery-right"></div>',
          autoInterval = null;

      var numSlides = $('.gallery__slide').length;
      var totalGalleryWidth = 0;
      $('.gallery__slide').each(function(i) {
        totalGalleryWidth += $(this).width();
        if ((i + 1) == numSlides) {
          if(totalGalleryWidth > $('.gallery__inner').width()) {
            gallery.append(leftArrow).append(rightArrow);
          }
        }
      });

      var autoIncrement = 10,
          intervalSpeed = 1;

      var galleryArrow = $('.gallery-arrow'),
          scrollLeftArrow = $('.gallery-arrow.gallery-left'),
          scrollRightArrow = $('.gallery-arrow.gallery-right').show();

      if (window.isTouch) {
        galleryArrow.hide();
      }

      galleryArrow.on('mouseenter', function() {
        var el = $(this);
        if (el.hasClass('gallery-left')) {
          autoScrollGallery('left');
        } else {
          autoScrollGallery('right');
        }
      }).mouseleave(function() {
        clearInterval(autoInterval);
      });

    

    function autoScrollGallery(direction) {
      if (isScrolling) return;
      var scrollTracker = 0;

      autoInterval = setInterval(function() {
        switch(direction) {
          case 'right':
            var newLeft = gallery.scrollLeft() + autoIncrement;
            gallery.scrollLeft(newLeft);
            scrollTracker = gallery.scrollLeft();
            arrowVisibility(newLeft, scrollTracker);
            break;
          case 'left':
            var newLeft = gallery.scrollLeft()-autoIncrement > 0 ? (gallery.scrollLeft()-autoIncrement) : 0;
            gallery.scrollLeft(newLeft);
            arrowVisibility(newLeft);
            break;
        }
      }, intervalSpeed);

      if (window.isTouch) {
        setTimeout(function() {
          clearInterval(autoInterval);
        }, 1000);
      }
    }

    function scrollGallery(dir, speed, amount) {
      dir = dir ? dir : 'right';
      speed = speed ? speed : 200;
      amount = amount ? amount : 650;

      switch(dir) {
        case 'right':
          gallery.animate({
            scrollLeft: gallery.scrollLeft()+amount
          }, speed, function() {
            isScrolling = false;
          });
          break;
        case 'left':
          gallery.animate({
            scrollLeft: gallery.scrollLeft()-amount > 0 ? (gallery.scrollLeft()-amount) : 0
          }, speed, function() {
            isScrolling = false;
          });
          break;
      }
    }

    function arrowVisibility(newLeft, oldLeft) {
      if (newLeft == 0) {
        scrollLeftArrow.fadeOut(150);
      }

      else if ( newLeft > oldLeft ) {
        scrollRightArrow.fadeOut(150);
      }

      else {
       scrollRightArrow.fadeIn(200);
       scrollLeftArrow.fadeIn(200);
      }

    }

  }
});

// -------------------------------------------------------------------------------------
// Timber Social Sharing
// -------------------------------------------------------------------------------------

window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $shareButtons       : $('.social-sharing')
  };
};

timber.init = function () {
  timber.cacheSelectors();
  timber.socialSharing();

  timber.isInitialized = true;
};

timber.socialSharing = function () {
  

  // General selectors
  var $buttons = timber.cache.$shareButtons,
      $shareLinks = $buttons.find('a'),
      permalink = $buttons.attr('data-permalink');

  // Share button selectors
  var $fbLink = $('.share-facebook'),
      $twitLink = $('.share-twitter'),
      $pinLink = $('.share-pinterest'),
      $googleLink = $('.share-google');

  if ($fbLink.length) {
    $.getJSON('https://graph.facebook.com/?id=' + permalink + '&callback=?', function (data) {
      if (data.shares) {
        $fbLink.find('.share-count').text(data.shares).addClass('is-loaded');
      } else {
        $fbLink.find('.share-count').remove();
      }
    });
  };

  if ($twitLink.length) {
    $.getJSON('https://cdn.api.twitter.com/1/urls/count.json?url=' + permalink + '&callback=?', function (data) {
      if (data.count > 0) {
        $twitLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $twitLink.find('.share-count').remove();
      }
    });
  };

  if ($pinLink.length) {
    $.getJSON('https://api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function (data) {
      if (data.count > 0) {
        $pinLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $pinLink.find('.share-count').remove();
      }
    });
  };

  if ($googleLink.length) {
    // Can't currently get Google+ count with JS, so just pretend it loaded
    $googleLink.find('.share-count').addClass('is-loaded');
  }

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var $el = $(this),
        popup = $el.attr('class').replace('-','_'),
        link = $el.attr('href'),
        w = 700,
        h = 400;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        h = 300;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }

    window.open(link, popup, 'width=' + w + ', height=' + h);
  });
};

// Initialize Timber's JS on docready
$(timber.init)

window.shop = window.shop || {};

shop.initCache = function () {
  shop.cache = {
    $window: $(window),
    $navContainer: $('.site-nav'),
    $navLinks: $('#SiteNavLinks'),
    $navLinkItems: $('.nav__primary--item'),
    $navFixedItems: $('.site-nav--item')
  }
};

shop.init = function () {
  shop.initCache();

  // Wait until fonts load to attempt creating 'more' link in nav
  shop.cache.$window.load(function() {
    shop.responsiveNav();
  });
};

shop.responsiveNav = function () {
  shop.cache.$window.on('resize', function() {
    shop.cache.$navContainer.removeClass('is-complete').addClass('is-processing');

    afterResize(function(){
      shop.resetNavWidth();
      shop.fixNavWidth();
    }, 200, 'fixNavWidth');
  });

  shop.fixNavWidth();
};

shop.fixNavWidth = function () {
  if (getWidth() < desktopBreakPoint) {
   return;
  }

  var $nav = shop.cache.$navLinks;
  var listItemsWidth = 0;
  var listItemIndex = 0;
  var widthForNav = 0;
  var fixedElementsWidth = 0;
  var containerWidth = shop.cache.$navContainer.width() - 110; // approx size of "more" link
  var menuhtml = '';

  // Figure out how much space we have to work with.
  // Container width minus logo, account/cart links, social links
  shop.cache.$navFixedItems.each(function(i, el) {
    fixedElementsWidth += parseInt($(el).outerWidth());
  });

  // Calculate the width the nav can take up
  widthForNav = containerWidth - fixedElementsWidth;

  // Calculate width of items until they overflow available
  // space, then hold them for future use.
  $nav.children().each(function(i, el) {
    var $el = $(el);
    listItemsWidth += $el.outerWidth(true);

    if (widthForNav < listItemsWidth) {
      menuhtml += $('<div>').append($el.clone()).html();
      $el.remove();

      listItemIndex++;
    }
  });

  if (widthForNav < listItemsWidth) {
    this.cache.$navLinks.append(
      '<li id="MoreMenu" class="nav__primary--item">'
        + '<a href="#">' + "More" + '</a>'
        + '<ul id="MoreMenuList" class="dropdown">' + menuhtml + '</ul></li>'
    );

    if (listItemIndex <= 1) {
      // Bail, and replace original nav items
      shop.resetNavWidth();
    }
  }

  // All done, show the nav
  shop.cache.$navContainer.removeClass('is-processing').addClass('is-complete');
};

shop.resetNavWidth = function () {
  shop.cache.$navLinks.append($('#MoreMenuList').html());
  $('#MoreMenu').remove();
};

$(shop.init);
